import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const getHemo = async (params: object) => {
  return await GET({ url: Api.home, params, showError: false })
}
export const getCityRuleDesc = async (params: object) => {
  return await GET({ url: Api.cityRuleDesc, params, showError: false })
}
export const getFlowLog = async (params: object) => {
  return await GET({ url: Api.flowLog, params, showError: false })
}
